import React from "react";

const PrivacyPolicy = () => {


    return (
        <div>
            <div className="container-fluid">
                <div className="row page-header p-0 m-0 ">
                <section className='blog-bg d-flex align-items-center justify-content-center'>
                <div className="">
                    <h1 className='text-white'>Privacy Policy</h1>
                </div>
            </section>
                </div>
                <div className="row justify-content-center my-5">
                <div className="col-lg-10">
                        <div>
                            <h1><strong>Nursing College Privacy Policy</strong></h1>

                            <h2><u>Introduction</u></h2>
                            <p>
                                <strong>[Name of College]</strong> (hereinafter referred to as "the College," "we," "us," or "our")
                                is committed to protecting the privacy and security of personal information. This Privacy Policy outlines the
                                types of information we collect, how we use it, who we share it with, and the rights and choices you have
                                regarding your personal information. This policy applies to all students, faculty, staff, and visitors of the College.
                            </p>

                            <h2><u>Information We Collect</u></h2>
                            <h3><b>Personal Information</b></h3>
                            <ul>
                                <li>Contact Information: Name, address, email address, and phone number.</li>
                                <li>Academic Information: Enrollment details, grades, course history, and attendance records.</li>
                                <li>Identification Information: Student ID, social security number, and government-issued identification.</li>
                                <li>Financial Information: Tuition payments, financial aid details, and bank account information.</li>
                                <li>Health Information: Medical records, immunization records, and disability status.</li>
                                <li>Employment Information: Job applications, employment history, and professional qualifications.</li>
                            </ul>
                            <h3><b>Non-Personal Information</b></h3>
                            <ul>
                                <li>Technical Information: IP addresses, browser type, operating system, and browsing history.</li>
                                <li>Usage Data: Information about how you use our website, services, and facilities.</li>
                            </ul>

                            <h2><u>How We Use Your Information</u></h2>
                            <ul>
                                <li>Academic Administration: Managing student records, course registrations, grading, and certification.</li>
                                <li>Support Services: Providing academic advising, counseling, and healthcare services.</li>
                                <li>Financial Administration: Processing tuition payments, scholarships, and financial aid.</li>
                                <li>Compliance: Complying with legal obligations, accreditation requirements, and reporting duties.</li>
                                <li>Communication: Sending important updates, newsletters, and information about events.</li>
                                <li>Security: Ensuring the safety and security of students, staff, and campus facilities.</li>
                                <li>Improvement: Enhancing our educational programs, services, and website functionality.</li>
                            </ul>

                            <h2><u>Information Sharing and Disclosure</u></h2>
                            <p>We do not sell or rent your personal information to third parties. We may share your information with:</p>
                            <ul>
                                <li>Service Providers: Third-party vendors who perform services on our behalf, such as IT support, payment processing, and data analytics.</li>
                                <li>Academic Partners: Institutions and organizations for collaborative educational programs and transfer of credits.</li>
                                <li>Government Authorities: Regulatory bodies, law enforcement, and other authorities as required by law.</li>
                                <li>Affiliated Entities: Organizations affiliated with the College for academic and administrative purposes.</li>
                            </ul>

                            <h2><u>Data Security</u></h2>
                            <p>We implement appropriate technical and organizational measures to protect personal information against unauthorized access, alteration, disclosure, or destruction. These measures include:</p>
                            <ul>
                                <li>Encryption: Using secure encryption methods for data transmission and storage.</li>
                                <li>Access Control: Restricting access to personal information to authorized personnel only.</li>
                                <li>Regular Audits: Conducting regular audits and security assessments to ensure compliance with data protection standards.</li>
                            </ul>

                            <h2><u>Your Rights and Choices</u></h2>
                            <ul>
                                <li>Access: Request access to your personal information and obtain a copy of it.</li>
                                <li>Correction: Request corrections to any inaccurate or incomplete information.</li>
                                <li>Deletion: Request the deletion of your personal information under certain conditions.</li>
                                <li>Objection: Object to the processing of your personal information for specific purposes.</li>
                                <li>Data Portability: Request the transfer of your personal information to another organization in a structured, commonly used format.</li>
                            </ul>

                            <h2><u>Cookies and Tracking Technologies</u></h2>
                            <p>Our website uses cookies and similar tracking technologies to enhance user experience and analyze website traffic. You can manage your cookie preferences through your browser settings.</p>

                            <h2><u>Changes to This Privacy Policy</u></h2>
                            <p>We may update this Privacy Policy from time to time to reflect changes in our practices or applicable laws. We will notify you of any significant changes by posting the new policy on our website and updating the effective date at the top of this page.</p>

                            <h2><u>Contact Us</u></h2>
                            <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:</p>
                            <ul>
                                <li>Email: [privacy@college.edu]</li>
                                <li>Phone: [Contact Number]</li>
                                <li>Address: [College Address]</li>
                            </ul>

                            <p><b>Effective Date:</b> [Date]</p>

                            <p>Please review this policy regularly to stay informed about how we are protecting your personal information.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
